export const leaveRequestOptions = [
  {
    label: 'Nghỉ phép',
    value: 'Nghỉ phép'
  },
  {
    label: 'Nghỉ không lương',
    value: 'Nghỉ không lương'
  },
  {
    label: 'Nghỉ hộ sản',
    value: 'Nghỉ hộ sản'
  },
  {
    label: 'Nghỉ tạm hoãn',
    value: 'Nghỉ tạm hoãn'
  }
]

export const applicationOptions = [
  {
    label: 'Office 365',
    value: '1'
  },
  {
    label: 'Adobe Photoshop',
    value: '2'
  },
  {
    label: 'Adobe Illustrator',
    value: '3'
  }
]

export const meetingTemplates = [
  {
    label: 'Họp giao ban khai thác tuần - VIAGS',
    value: '1',
  },
  {
    label: 'Họp bộ phận nhân sự - VIAGS',
    value: '2',
  }
]

export const attendeesOptions = [
  {
    text: 'Ban lãnh đạo các chi nhánh',
    id: '1',
  },
  {
    text: 'Lãnh đạo phòng ATCL',
    id: '2',
  }
]

export const codeProcessEprOptions = [
  {
    label: 'Đoàn tiếp viên',
    value: 'Đoàn tiếp viên'
  },
  {
    label: 'Công nghệ thông tin',
    value: 'Công nghệ thông tin'
  },
  {
    label: 'Tài chính - kế toán',
    value: 'Tài chính -kế toán'
  },
  {
    label: 'Marketing',
    value: 'Marketing'
  }  
]

export const deviceTypeOptions = [
  {
    label: 'Màn hình máy tính',
    value: 'Màn hình máy tính'
  },
  {
    label: 'CPU',
    value: 'CPU'
  },
  {
    label: 'Bàn Phím',
    value: 'Bàn Phím'
  },
  {
    label: 'Máy in',
    value: 'Máy in'
  }  

]

export const deleteUserAccountOptions = [
  {
    label: 'Tài Khoản EPR',
    value: 'Tài Khoản EPR'
  },
  {
    label: 'Tài Khoản Code VMS',
    value: 'Tài Khoản Code VMS'
  },
  {
    label: 'Tài Khoản Gmail',
    value: 'Tài Khoản Gmail'
  },
  {
    label: 'Tài Khoản Người Dùng Máy Tính',
    value: 'Tài Khoản Người Dùng Máy Tính'
  },
  {
    label: 'Xóa Tất Cả Tài Khoản',
    value: 'Xóa Tất Cả Tài Khoản'
  }

]
export const toolRequestOptions = [
  {
    label: 'Máy Tính',
    value: 'Máy Tính'
  },
  {
    label: 'Máy In',
    value: 'Máy In'
  },
  {
    label: 'Chuột',
    value: 'Chuột'
  },
  {
    label: 'Bàn Phím',
    value: 'Bàn Phím'
  },
  {
    label: 'Cáp HTML',
    value: 'Cáp HTML'
  }


]


export const codeTSCCOptions = [
  {
    label: 'VNA001',
    value: 'VNA001'
  },
  {
    label: 'VNA002',
    value: 'VNA002'
  },
  {
    label: 'VNA003',
    value: 'VNA003'
  },
  {
    label: 'VNA004',
    value: 'VNA004'
  }  
]

export const unitRoomOptions = [
  {
    label: 'Công nghệ thông tin',
    value: 'Công nghệ thông tin'
  },
  {
    label: 'Phòng kế hoạch',
    value: 'Phòng kế hoạch'
  },
  {
    label: 'Văn phòng công ty',
    value: 'Văn phòng công ty'
  },
  {
    label: 'Phòng nhân sự',
    value: 'Phòng nhân sự'
  },
  {
    label: 'Phòng an toàn',
    value: 'Phòng an toàn'
  },
  {
    label: 'Phòng đào tạo',
    value: 'Phòng đào tạo'
  },
  {
    label: 'Marketing',
    value: 'Marketing'
  },
  {
    label: 'Đoàn tiếp viên',
    value: 'Đoàn tiếp viên'
  },
]
